import React, { Component } from 'react';
import {BrowserRouter , Switch , Route , Redirect} from "react-router-dom"
import LandingPage from "../src/LandingPage/LandingPage"
import './App.css';
import OtakuDimension from "./Dimension/ShonenDimension/Shonen"
import SliceOfLife from "./Container/Catagories/SliceOfLife"
import Romantic from "./Container/Catagories/Romentic"
import Comedy from "./Container/Catagories/Comedy"
import Shonen from "./Container/Catagories/Shonen"
import SliceOfLifeDimension from './Dimension/SliceOfLifeDimension/sliceOfLife'
import RomenticContent from "./Dimension/RomenticDimension/Romentic"
import ComedyContent from "./Dimension/ComedyDimension/Comedy"
import Signup from "./Authentication/Signup"
import AddAnime from "./Component/postAnime/AddAnime"
import {connect} from "react-redux"
import Navigation from "./Container/Navigation"

const App =(props)=> {
  
 
  let route = ( 
  <Switch>
  <Route path="/" component={Signup}/>
  <Redirect to="/"/>
  </Switch>
  )
    
  if (props.isAuthenticated){
    route = (
      
    <Switch>

            <Route path="/home" exact component={LandingPage}/> 
            <Route path="/shonenDimension" exact component={OtakuDimension}   />
            <Route path="/sliceOfLife" exact component={SliceOfLife}   />
            <Route path="/romantic" exact component={Romantic}   />
            <Route path="/comedy" exact component={Comedy}   />
            <Route path="/shonen"  component={Shonen} />  
            <Route path="/sliceOfLifeDimension" component={SliceOfLifeDimension} />
            <Route path="/romenticDimension" component={RomenticContent} />
            <Route path="/ComedyDimension" component={ComedyContent} />
            <Route path="/signup" component={Signup}/> 
            <Route path="/addAnime" component={AddAnime}/> 
        <Redirect to="/home"/>
    </Switch>      
    )
  }


    return (   
      <BrowserRouter>

    <div className="App">
   <Navigation/>
  {route}  
    </div>   

</BrowserRouter> 
    )  
  }




const mapStateToProps=state=>{
  return {
  isAuthenticated : state.auth.token!==null
  }
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js